import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-py-[59px] tw-pl-[14%] md:tw-py-[57px] md:tw-pl-0 md:tw-text-center" }
const _hoisted_2 = { class: "md:tw-inline-block tw-mb-2 md:tw-mb-0 md:tw-mx-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/sitemedia/mf-logo2.png",
  alt: "Mathsframe Ltd. Logo",
  class: "mf-logo-filter tw-w-[344px]"
}, null, -1)
const _hoisted_4 = { class: "md:tw-inline-block md:tw-mx-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/sitemedia/sf-logo2.png",
  alt: "Spellingframe Ltd. Logo",
  class: "sf-logo-filter tw-w-[344px]"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SfRouterLink, { to: _ctx.mathsHomeUrl }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SfRouterLink, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}